export default __webpack_public_path__ + "static/media/SurveyChat.c30825ee.svg";